import { render, staticRenderFns } from "./ChartLosses.vue?vue&type=template&id=94f2881a"
import script from "./ChartLosses.vue?vue&type=script&lang=js"
export * from "./ChartLosses.vue?vue&type=script&lang=js"
import style0 from "./ChartLosses.vue?vue&type=style&index=0&id=94f2881a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports